import BarcodeScanner from './BarcodeScanner';

export default BarcodeScanner;
